import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]

import { RouterLink } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonLink',
  props: {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  ...RouterLink.props,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RouterLink), _mergeProps(_ctx.$props, { custom: "" }), {
    default: _withCtx(({ navigate }) => [
      _createElementVNode("button", _mergeProps(_ctx.$attrs, {
        type: "button",
        onClick: navigate,
        class: "btn"
      }), [
        _renderSlot(_ctx.$slots, "default")
      ], 16, _hoisted_1)
    ]),
    _: 3
  }, 16))
}
}

})